export function dollarsToCents(dollarAmount: number) {
  return Math.round(dollarAmount * 100)
}

export function centsToDollars(centAmount: number) {
  return Number((centAmount / 100).toFixed(2))
}
